import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLockInfoAdjustments = createSelector(
  selectLoanApplication,
  ({ lockInfoAdjustments }) => lockInfoAdjustments,
);

export const selectLockExtensionSettings = createSelector(
  selectLockInfoAdjustments,
  ({ lockExtensionSettings }) => lockExtensionSettings,
);

export const selectMaxExtensionPeriodDays = createSelector(
  selectLockInfoAdjustments,
  ({ maxExtensionPeriodDays }) => maxExtensionPeriodDays,
);
